import { useNavigate } from "react-router-dom";
import { Phone, CalendarCheck } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { openWhatsApp, TEL_NUMBER } from "@/lib/depannage";

const WA_TXT = {
  fr: "Bonjour Garage Ter Spelt, j'ai une question concernant mon véhicule.",
  nl: "Hallo Garage Ter Spelt, ik heb een vraag over mijn voertuig.",
  en: "Hello Garage Ter Spelt, I have a question about my vehicle.",
};

const WhatsAppIcon = ({ className }) => (
  <svg viewBox="0 0 32 32" className={className} fill="currentColor" aria-hidden>
    <path d="M16.003 3C9.383 3 4 8.383 4 15c0 2.113.553 4.176 1.602 5.998L4 29l8.2-1.57A11.94 11.94 0 0016.003 27C22.62 27 28 21.617 28 15S22.62 3 16.003 3zm0 21.8c-1.85 0-3.66-.5-5.24-1.44l-.376-.222-4.868.932.93-4.744-.245-.39A9.77 9.77 0 016.2 15c0-5.404 4.398-9.8 9.803-9.8 5.404 0 9.797 4.396 9.797 9.8 0 5.404-4.393 9.8-9.797 9.8zm5.377-7.33c-.294-.147-1.74-.858-2.01-.956-.27-.098-.466-.147-.663.148-.196.294-.76.955-.932 1.152-.172.196-.343.22-.637.073-.294-.147-1.242-.458-2.366-1.46-.874-.78-1.464-1.744-1.636-2.038-.171-.294-.018-.453.13-.6.133-.132.294-.343.44-.514.148-.172.196-.294.295-.49.098-.197.05-.368-.025-.515-.073-.147-.663-1.597-.908-2.187-.24-.575-.483-.497-.663-.506l-.565-.01c-.196 0-.514.073-.784.368-.27.294-1.03 1.006-1.03 2.456 0 1.45 1.055 2.85 1.202 3.047.147.196 2.075 3.17 5.03 4.444.703.303 1.25.484 1.678.62.705.224 1.346.192 1.853.116.565-.084 1.74-.71 1.985-1.397.245-.686.245-1.274.171-1.397-.073-.122-.27-.196-.564-.343z"/>
  </svg>
);

export function MobileTabBar() {
  const { t, lang } = useLang();
  const navigate = useNavigate();
  const cell = "flex flex-col items-center justify-center gap-1 py-2.5 active:scale-95 transition-transform";
  const lblCls = "font-mono-tech text-[10px] uppercase tracking-[0.1em]";
  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-[60] bg-[#0A0A0C]/95 backdrop-blur border-t border-white/10 grid grid-cols-3" data-testid="mobile-tabbar">
      <a href={`tel:${TEL_NUMBER}`} className={`${cell} text-white`} data-testid="mtab-call">
        <Phone className="w-5 h-5 text-[#00E5FF]" />
        <span className={lblCls}>{t("mobilebar.call")}</span>
      </a>
      <button onClick={() => openWhatsApp(WA_TXT[lang] || WA_TXT.fr)} className={`${cell} text-white`} data-testid="mtab-whatsapp">
        <WhatsAppIcon className="w-5 h-5 text-[#25D366]" />
        <span className={lblCls}>WhatsApp</span>
      </button>
      <button onClick={() => navigate("/booking")} className={`${cell} bg-[#E60000] text-white`} data-testid="mtab-book">
        <CalendarCheck className="w-5 h-5" />
        <span className={lblCls}>{t("mobilebar.book")}</span>
      </button>
    </nav>
  );
}
